module.exports = __webpack_public_path__ + "media/images/badges/regenerative-ecosystems-100-28024add311adadc64e656e2fe3cc1b8.svg";